import { render, staticRenderFns } from "./v-sign.vue?vue&type=template&id=a6b80aa2&scoped=true&"
import script from "./v-sign.vue?vue&type=script&lang=js&"
export * from "./v-sign.vue?vue&type=script&lang=js&"
import style0 from "./v-sign.vue?vue&type=style&index=0&id=a6b80aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b80aa2",
  null
  
)

export default component.exports